  <div class="web-channel-card position-relative">
    <div class="position-absolute w-100 h-100 masking-div"
      *ngIf="docCardObj?.content_visibility?.display==0 || docCardObj?.content_visibility?.display==2">
      <app-product-masking-card [content_visibility]="docCardObj.content_visibility"></app-product-masking-card>
    </div>
    <div class="border clearfix overflow-hidden cursor-pointer web-channel-card-wrapper" *ngIf="docTalkSection !='explore_phrm'">
      <div class="doctlk-img overflow-hidden position-relative" (click)="navigatetoChanneldetail(docCardObj?.channel_id)">
        <img loading="lazy" src={{docCardObj?.banner}} class="post-pic"
          onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" />
        <!-- details page while playing -->
  
      </div>
      <div class="p-2">
        <!-- heading -->
        <p class="paragraph" (click)="navigatetoChanneldetail(docCardObj?.channel_id)">
          {{docCardObj?.title}}</p>
        <p class="mt-2 mb-2 clearfix secondary-paragraph"
          (click)="navigatetoChanneldetail(docCardObj?.channel_id)">
          <span class="clinical-compny position-relative float-left">
            <img loading="lazy" class="mr-1 mt-0 post-pic rounded-circle" src={{docCardObj?.powered_by}}
              onerror="this.src='assets/themes/icons/channel-placeholder.svg'"></span>
          <span class="float-left channel-name-max-width w-100">
            {{docCardObj?.powered_by_label}} {{docCardObj?.powered_name}}
          </span>
        </p>
  
        <button (click)="showSubscribe(docCardObj?.safe_url)" *ngIf="docCardObj?.is_subscribed==0 && (this.mls.featureOnOffList.featureList.myVault.value || !mls.userLoginFlow)"
          class="my-2 d-block btn-design outline small w-100">+
          {{mls?.languageText?.channel_card?.key1}}<span
            *ngIf="mls?.is_lskey_display==1">(channel_card?.key1)</span></button>
        
        <div *ngIf="docCardObj?.is_subscribed==0" class="primary-small">
          <label class="checkbox primary-small">
            <input [checked]="showSubscribeChecked==true" (change)="change($event)" id="subscribeCbx" type="checkbox">
            <span>{{mls?.languageText?.channel_card?.key2}} <span *ngIf="mls?.is_lskey_display==1">(channel_card?.key2)</span> </span>
          </label>
          <span class="primary-small ml-1 cursor-pointer" (click)="showtnc()"><span class="color-blue">{{mls?.languageText?.channel_card?.key3}}<span
            *ngIf="mls?.is_lskey_display==1">(channel_card?.key3)</span></span></span> 
          <p class="erroMsg color-error" *ngIf="erroMsg==true">{{mls?.languageText?.channel_card?.key4}}<span
            *ngIf="mls?.is_lskey_display==1">(channel_card?.key4)</span></p>
        </div>
      </div>
    </div>
  
    <!-- speakers card -->
    <div class="clearfix py-2 px-3 cursor-pointer channel-speaker-card"
      *ngIf="docTalkSection =='explore_phrm' && sectionName!='exploer_view_all'"
      (click)="navigatetodetail(docCardObj?.id)">
      <div class="float-left mr-2 user-60">
        <img loading="lazy" src={{docCardObj?.powered_by}} class="post-pic user-60 rounded-circle"
          onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'" />
      </div>
      <div class="float-left speakers-card-max-width">
        <p class="secondary-paragraph-bold"><span>{{docCardObj?.powered_name}}</span></p>
        <p class="primary-small">{{docCardObj?.total_channel}}</p>
        <p class="primary-small">
          <span class="clinical-compny mr-4 position-relative color-grey-500">{{docCardObj?.no_of_members}}</span>
        </p>
      </div>
    </div>
  
  
    <div class="clearfix overflow-hidden cursor-pointer channel-speaker-card"
      *ngIf="docTalkSection =='explore_phrm'  && sectionName=='exploer_view_all'"
      (click)="navigatetodetail(docCardObj?.id)">
      <div class="doctlk-img overflow-hidden position-relative">
        <img loading="lazy" src={{docCardObj?.powered_by}} class="post-pic"
          onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
      </div>
      <div class="p-2 bg-white">
        <p class="secondary-paragraph-bold"><span>{{docCardObj?.powered_name}}</span></p>
        <p class="primary-small">{{docCardObj?.total_channel}}</p>
        <p class="primary-small">
          <span class="clinical-compny mr-4 position-relative color-grey-500">{{docCardObj?.no_of_members}}</span>
        </p>
      </div>
    </div>
  </div>
  <!-- subscribe popup start**************************** -->
  <!-- subscribe popup end**************************** -->